import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 10,
  path: '/expert',
  component: Home,
  redirect: '/expert/expertService/appoint',
  name: 'expert',
  isHead: true,
  meta: {
    title: '专家服务',
    icon: 'el-icon-s-custom'
  },
  children: [
    {
      path: 'expertService',
      name: 'expertService',
      component: () => import('@/views/expert/index'),
      meta: { title: '专家服务', close: false },
      children: [
        {
          path: 'appoint',
          name: 'appoint',
          component: () => import('@/views/expert/appoint/index'),
          meta: { title: '专家选派', close: false, next:'/expert/expertService/expertManagement' },
        },
        {
          path: 'expertManagement',
          name: 'expertManagement',
          component: () => import('@/views/expert/expertManagement/index'),
          meta: { title: '专家管理', close: false },
        },
      ],
    }
  ]
}

export default home


// WEBPACK FOOTER //
// ./src/router/modules/expert.js